// store.js
import { reactive } from "vue";

export const store = reactive({
  webAPIUrl: process.env.VUE_APP_ROOT_API_URL, //can move this to appsettings.js (different configs etc.)
  //initial assumptions: the user is not logged in, the app is not mounted, and the backend is healthy
  //User with admin role: 5039
  //User without admin role: 610
  loggedIn: false,
  appIsMounted: false,
  backendIsHealthy: true,
  
  authenticatedUser: {},
  healthStatus: {},
  tempContractId: 0,
  tempUserProfileId: 5039,
  tempUserEmail: "admin@caamsng.mil",
  tempPersonId:0,
  tempCompanyId:0,
  tempSearchCriteria:null,
  //set to true to disable ALL console logs across the entire application.
  disableAllConsoleLogsGlobally: false,
  //Set to true to bypass the landing page when not logged in, or the backend project is not running
  globalDebugging:false,
  //if you want to impersonate a user role for the purpose of the side menu, set it here: 
  //NOTE: this will get overwritten by your login user role if you do log in. 
  spoofRoleDebugging: "Admin",
  tempMasterPersonListResultsPerPage:0
});
